export const Assets = {
    "IMG_01_STAKING_TABLE": {
        "type": "IMAGE",
        "key": "IMG_01_STAKING_TABLE",
        "imageUrl": "assets/images/01_staking_table.png"
    },
    "IMG_02_STAKING_TABLE": {
        "type": "IMAGE",
        "key": "IMG_02_STAKING_TABLE",
        "imageUrl": "assets/images/02_staking_table.png"
    },
    "IMG_BAG_01": {
        "type": "IMAGE",
        "key": "IMG_BAG_01",
        "imageUrl": "assets/images/bag_01.png"
    },
    "IMG_BAG": {
        "type": "IMAGE",
        "key": "IMG_BAG",
        "imageUrl": "assets/images/bag.png"
    },
    "IMG_BAICE": {
        "type": "IMAGE",
        "key": "IMG_BAICE",
        "imageUrl": "assets/images/baice.png"
    },
    "IMG_BAR_01": {
        "type": "IMAGE",
        "key": "IMG_BAR_01",
        "imageUrl": "assets/images/bar_01.png"
    },
    "IMG_BG_STON_003": {
        "type": "IMAGE",
        "key": "IMG_BG_STON_003",
        "imageUrl": "assets/images/bg_ston_003.png"
    },
    "IMG_BG_STON_01": {
        "type": "IMAGE",
        "key": "IMG_BG_STON_01",
        "imageUrl": "assets/images/bg_ston_01.png"
    },
    "IMG_BG_STON_02": {
        "type": "IMAGE",
        "key": "IMG_BG_STON_02",
        "imageUrl": "assets/images/bg_ston_02.png"
    },
    "IMG_BG_STON_04": {
        "type": "IMAGE",
        "key": "IMG_BG_STON_04",
        "imageUrl": "assets/images/bg_ston_04.png"
    },
    "IMG_BG_STON_05": {
        "type": "IMAGE",
        "key": "IMG_BG_STON_05",
        "imageUrl": "assets/images/bg_ston_05.png"
    },
    "IMG_BIG_UI_BORD": {
        "type": "IMAGE",
        "key": "IMG_BIG_UI_BORD",
        "imageUrl": "assets/images/big_ui_bord.png"
    },
    "IMG_BIN": {
        "type": "IMAGE",
        "key": "IMG_BIN",
        "imageUrl": "assets/images/bin.png"
    },
    "IMG_BOX_UPGRADE": {
        "type": "IMAGE",
        "key": "IMG_BOX_UPGRADE",
        "imageUrl": "assets/images/box_upgrade.png"
    },
    "IMG_BOX_UPGRADE1": {
        "type": "IMAGE",
        "key": "IMG_BOX_UPGRADE1",
        "imageUrl": "assets/images/box_upgrade1.png"
    },
    "IMG_BOX_UPGRADE2": {
        "type": "IMAGE",
        "key": "IMG_BOX_UPGRADE2",
        "imageUrl": "assets/images/box_upgrade2.png"
    },
    "IMG_BOX_UPGRADE3": {
        "type": "IMAGE",
        "key": "IMG_BOX_UPGRADE3",
        "imageUrl": "assets/images/box_upgrade3.png"
    },
    "IMG_BOX_UPGRADE4": {
        "type": "IMAGE",
        "key": "IMG_BOX_UPGRADE4",
        "imageUrl": "assets/images/box_upgrade4.png"
    },
    "IMG_BREAK_MSG": {
        "type": "IMAGE",
        "key": "IMG_BREAK_MSG",
        "imageUrl": "assets/images/break_msg.png"
    },
    "IMG_BREAK_TITLE1": {
        "type": "IMAGE",
        "key": "IMG_BREAK_TITLE1",
        "imageUrl": "assets/images/break_title1.png"
    },
    "IMG_BREAK_TITLE2": {
        "type": "IMAGE",
        "key": "IMG_BREAK_TITLE2",
        "imageUrl": "assets/images/break_title2.png"
    },
    "IMG_BUSH_01": {
        "type": "IMAGE",
        "key": "IMG_BUSH_01",
        "imageUrl": "assets/images/bush_01.png"
    },
    "IMG_BUSH_02": {
        "type": "IMAGE",
        "key": "IMG_BUSH_02",
        "imageUrl": "assets/images/bush_02.png"
    },
    "IMG_CANDY_BOARD": {
        "type": "IMAGE",
        "key": "IMG_CANDY_BOARD",
        "imageUrl": "assets/images/candy_board.png"
    },
    "IMG_CANDY_MACHINE": {
        "type": "IMAGE",
        "key": "IMG_CANDY_MACHINE",
        "imageUrl": "assets/images/candy_machine.png"
    },
    "IMG_CANDY": {
        "type": "IMAGE",
        "key": "IMG_CANDY",
        "imageUrl": "assets/images/candy.png"
    },
    "IMG_CASHIER_ICON": {
        "type": "IMAGE",
        "key": "IMG_CASHIER_ICON",
        "imageUrl": "assets/images/cashier_icon.png"
    },
    "IMG_CHARACTER_01": {
        "type": "IMAGE",
        "key": "IMG_CHARACTER_01",
        "imageUrl": "assets/images/character_01.png"
    },
    "IMG_CHARACTER_02": {
        "type": "IMAGE",
        "key": "IMG_CHARACTER_02",
        "imageUrl": "assets/images/character_02.png"
    },
    "IMG_CIRCLE": {
        "type": "IMAGE",
        "key": "IMG_CIRCLE",
        "imageUrl": "assets/images/circle.png"
    },
    "IMG_CLOCK_BASE2": {
        "type": "IMAGE",
        "key": "IMG_CLOCK_BASE2",
        "imageUrl": "assets/images/clock_base2.png"
    },
    "IMG_CLOS_BUTTON": {
        "type": "IMAGE",
        "key": "IMG_CLOS_BUTTON",
        "imageUrl": "assets/images/clos_button.png"
    },
    "IMG_CONTINUE": {
        "type": "IMAGE",
        "key": "IMG_CONTINUE",
        "imageUrl": "assets/images/continue.png"
    },
    "IMG_CONTROL_KEY": {
        "type": "IMAGE",
        "key": "IMG_CONTROL_KEY",
        "imageUrl": "assets/images/control_key.png"
    },
    "IMG_DISABLE_ICON_01": {
        "type": "IMAGE",
        "key": "IMG_DISABLE_ICON_01",
        "imageUrl": "assets/images/disable_icon_01.png"
    },
    "IMG_DOWNARROW": {
        "type": "IMAGE",
        "key": "IMG_DOWNARROW",
        "imageUrl": "assets/images/downarrow.png"
    },
    "IMG_FRAME_01": {
        "type": "IMAGE",
        "key": "IMG_FRAME_01",
        "imageUrl": "assets/images/frame_01.png"
    },
    "IMG_FRIDGE_01_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_01_SMALL",
        "imageUrl": "assets/images/fridge_01_small.png"
    },
    "IMG_FRIDGE_01": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_01",
        "imageUrl": "assets/images/fridge_01.png"
    },
    "IMG_FRIDGE_02_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_02_SMALL",
        "imageUrl": "assets/images/fridge_02_small.png"
    },
    "IMG_FRIDGE_02": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_02",
        "imageUrl": "assets/images/fridge_02.png"
    },
    "IMG_FRIDGE_FRAME_01_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME_01_SMALL",
        "imageUrl": "assets/images/fridge_frame_01_small.png"
    },
    "IMG_FRIDGE_FRAME_01": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME_01",
        "imageUrl": "assets/images/fridge_frame_01.png"
    },
    "IMG_FRIDGE_FRAME_02_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME_02_SMALL",
        "imageUrl": "assets/images/fridge_frame_02_small.png"
    },
    "IMG_FRIDGE_FRAME_02": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME_02",
        "imageUrl": "assets/images/fridge_frame_02.png"
    },
    "IMG_FRIDGE_FRAME_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME_SMALL",
        "imageUrl": "assets/images/fridge_frame_small.png"
    },
    "IMG_FRIDGE_FRAME": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_FRAME",
        "imageUrl": "assets/images/fridge_frame.png"
    },
    "IMG_FRIDGE_SMALL": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE_SMALL",
        "imageUrl": "assets/images/fridge_small.png"
    },
    "IMG_FRIDGE": {
        "type": "IMAGE",
        "key": "IMG_FRIDGE",
        "imageUrl": "assets/images/fridge.png"
    },
    "IMG_GATE": {
        "type": "IMAGE",
        "key": "IMG_GATE",
        "imageUrl": "assets/images/gate.png"
    },
    "IMG_GRAPE_BOARD": {
        "type": "IMAGE",
        "key": "IMG_GRAPE_BOARD",
        "imageUrl": "assets/images/grape_board.png"
    },
    "IMG_GRAPE_PLANT": {
        "type": "IMAGE",
        "key": "IMG_GRAPE_PLANT",
        "imageUrl": "assets/images/grape_plant.png"
    },
    "IMG_GRAPE_SUGAR_BOARD": {
        "type": "IMAGE",
        "key": "IMG_GRAPE_SUGAR_BOARD",
        "imageUrl": "assets/images/grape_sugar_board.png"
    },
    "IMG_GRAPE": {
        "type": "IMAGE",
        "key": "IMG_GRAPE",
        "imageUrl": "assets/images/grape.png"
    },
    "IMG_GREEN_TICK": {
        "type": "IMAGE",
        "key": "IMG_GREEN_TICK",
        "imageUrl": "assets/images/green_tick.png"
    },
    "IMG_HELPER_ORANGE_SLEEP_0001": {
        "type": "IMAGE",
        "key": "IMG_HELPER_ORANGE_SLEEP_0001",
        "imageUrl": "assets/images/helper_orange_sleep_0001.png"
    },
    "IMG_HELPER1": {
        "type": "IMAGE",
        "key": "IMG_HELPER1",
        "imageUrl": "assets/images/helper1.png"
    },
    "IMG_HELPER2": {
        "type": "IMAGE",
        "key": "IMG_HELPER2",
        "imageUrl": "assets/images/helper2.png"
    },
    "IMG_HELPER3": {
        "type": "IMAGE",
        "key": "IMG_HELPER3",
        "imageUrl": "assets/images/helper3.png"
    },
    "IMG_HELPER4": {
        "type": "IMAGE",
        "key": "IMG_HELPER4",
        "imageUrl": "assets/images/helper4.png"
    },
    "IMG_HOUR_HAND": {
        "type": "IMAGE",
        "key": "IMG_HOUR_HAND",
        "imageUrl": "assets/images/hour_hand.png"
    },
    "IMG_ICON_BORD": {
        "type": "IMAGE",
        "key": "IMG_ICON_BORD",
        "imageUrl": "assets/images/icon_bord.png"
    },
    "IMG_INSTRUCTION_M": {
        "type": "IMAGE",
        "key": "IMG_INSTRUCTION_M",
        "imageUrl": "assets/images/instruction_m.png"
    },
    "IMG_INSTRUCTION": {
        "type": "IMAGE",
        "key": "IMG_INSTRUCTION",
        "imageUrl": "assets/images/instruction.png"
    },
    "IMG_JAM_BOARD": {
        "type": "IMAGE",
        "key": "IMG_JAM_BOARD",
        "imageUrl": "assets/images/jam_board.png"
    },
    "IMG_JAM_MACHINE": {
        "type": "IMAGE",
        "key": "IMG_JAM_MACHINE",
        "imageUrl": "assets/images/jam_machine.png"
    },
    "IMG_JAM": {
        "type": "IMAGE",
        "key": "IMG_JAM",
        "imageUrl": "assets/images/jam.png"
    },
    "IMG_JUIC_MACHINE_01": {
        "type": "IMAGE",
        "key": "IMG_JUIC_MACHINE_01",
        "imageUrl": "assets/images/juic_machine_01.png"
    },
    "IMG_JUIC_MACHINE_02": {
        "type": "IMAGE",
        "key": "IMG_JUIC_MACHINE_02",
        "imageUrl": "assets/images/juic_machine_02.png"
    },
    "IMG_JUIC_MACHINE": {
        "type": "IMAGE",
        "key": "IMG_JUIC_MACHINE",
        "imageUrl": "assets/images/juic_machine.png"
    },
    "IMG_JUIC": {
        "type": "IMAGE",
        "key": "IMG_JUIC",
        "imageUrl": "assets/images/juic.png"
    },
    "IMG_JUICE_01": {
        "type": "IMAGE",
        "key": "IMG_JUICE_01",
        "imageUrl": "assets/images/juice_01.png"
    },
    "IMG_JUICE_02": {
        "type": "IMAGE",
        "key": "IMG_JUICE_02",
        "imageUrl": "assets/images/juice_02.png"
    },
    "IMG_JUICE0_BOARD": {
        "type": "IMAGE",
        "key": "IMG_JUICE0_BOARD",
        "imageUrl": "assets/images/juice0_board.png"
    },
    "IMG_JUICE1_BOARD": {
        "type": "IMAGE",
        "key": "IMG_JUICE1_BOARD",
        "imageUrl": "assets/images/juice1_board.png"
    },
    "IMG_JUICE2_BOARD": {
        "type": "IMAGE",
        "key": "IMG_JUICE2_BOARD",
        "imageUrl": "assets/images/juice2_board.png"
    },
    "IMG_LINE": {
        "type": "IMAGE",
        "key": "IMG_LINE",
        "imageUrl": "assets/images/line.png"
    },
    "IMG_LOGOBLUR1": {
        "type": "IMAGE",
        "key": "IMG_LOGOBLUR1",
        "imageUrl": "assets/images/logoblur1.png"
    },
    "IMG_MENU_BG": {
        "type": "IMAGE",
        "key": "IMG_MENU_BG",
        "imageUrl": "assets/images/menu_bg.png"
    },
    "IMG_MONEY_MISSION": {
        "type": "IMAGE",
        "key": "IMG_MONEY_MISSION",
        "imageUrl": "assets/images/money_mission.png"
    },
    "IMG_MONEY": {
        "type": "IMAGE",
        "key": "IMG_MONEY",
        "imageUrl": "assets/images/money.png"
    },
    "IMG_NO_THANKS": {
        "type": "IMAGE",
        "key": "IMG_NO_THANKS",
        "imageUrl": "assets/images/no_thanks.png"
    },
    "IMG_ORANGE_BOARD": {
        "type": "IMAGE",
        "key": "IMG_ORANGE_BOARD",
        "imageUrl": "assets/images/orange_board.png"
    },
    "IMG_ORANGE_PLANT": {
        "type": "IMAGE",
        "key": "IMG_ORANGE_PLANT",
        "imageUrl": "assets/images/orange_plant.png"
    },
    "IMG_ORANGE_SUGAR_BOARD": {
        "type": "IMAGE",
        "key": "IMG_ORANGE_SUGAR_BOARD",
        "imageUrl": "assets/images/orange_sugar_board.png"
    },
    "IMG_ORANGE": {
        "type": "IMAGE",
        "key": "IMG_ORANGE",
        "imageUrl": "assets/images/orange.png"
    },
    "IMG_PINEAPPLE_BOARD": {
        "type": "IMAGE",
        "key": "IMG_PINEAPPLE_BOARD",
        "imageUrl": "assets/images/pineapple_board.png"
    },
    "IMG_PINEAPPLE_PLANT_01": {
        "type": "IMAGE",
        "key": "IMG_PINEAPPLE_PLANT_01",
        "imageUrl": "assets/images/pineapple_plant_01.png"
    },
    "IMG_PINEAPPLE_PLANT_02": {
        "type": "IMAGE",
        "key": "IMG_PINEAPPLE_PLANT_02",
        "imageUrl": "assets/images/pineapple_plant_02.png"
    },
    "IMG_PINEAPPLE_SUGAR_BOARD": {
        "type": "IMAGE",
        "key": "IMG_PINEAPPLE_SUGAR_BOARD",
        "imageUrl": "assets/images/pineapple_sugar_board.png"
    },
    "IMG_PINEAPPLE": {
        "type": "IMAGE",
        "key": "IMG_PINEAPPLE",
        "imageUrl": "assets/images/pineapple.png"
    },
    "IMG_PLANTING_TILE_01": {
        "type": "IMAGE",
        "key": "IMG_PLANTING_TILE_01",
        "imageUrl": "assets/images/planting_tile_01.png"
    },
    "IMG_PLANTING_TILE_02": {
        "type": "IMAGE",
        "key": "IMG_PLANTING_TILE_02",
        "imageUrl": "assets/images/planting_tile_02.png"
    },
    "IMG_PLATE_01": {
        "type": "IMAGE",
        "key": "IMG_PLATE_01",
        "imageUrl": "assets/images/plate_01.png"
    },
    "IMG_PLATE_02": {
        "type": "IMAGE",
        "key": "IMG_PLATE_02",
        "imageUrl": "assets/images/plate_02.png"
    },
    "IMG_PLAY_BUTTON": {
        "type": "IMAGE",
        "key": "IMG_PLAY_BUTTON",
        "imageUrl": "assets/images/play_button.png"
    },
    "IMG_POPUP_01": {
        "type": "IMAGE",
        "key": "IMG_POPUP_01",
        "imageUrl": "assets/images/popup_01.png"
    },
    "IMG_POPUP": {
        "type": "IMAGE",
        "key": "IMG_POPUP",
        "imageUrl": "assets/images/popup.png"
    },
    "IMG_SELECTCHAR": {
        "type": "IMAGE",
        "key": "IMG_SELECTCHAR",
        "imageUrl": "assets/images/selectchar.png"
    },
    "IMG_SHADOW": {
        "type": "IMAGE",
        "key": "IMG_SHADOW",
        "imageUrl": "assets/images/shadow.png"
    },
    "IMG_SOUND_OFF_GAME": {
        "type": "IMAGE",
        "key": "IMG_SOUND_OFF_GAME",
        "imageUrl": "assets/images/sound_off_game.png"
    },
    "IMG_SOUND_OFF": {
        "type": "IMAGE",
        "key": "IMG_SOUND_OFF",
        "imageUrl": "assets/images/sound_off.png"
    },
    "IMG_SOUND_ON_GAME": {
        "type": "IMAGE",
        "key": "IMG_SOUND_ON_GAME",
        "imageUrl": "assets/images/sound_on_game.png"
    },
    "IMG_SOUND_ON": {
        "type": "IMAGE",
        "key": "IMG_SOUND_ON",
        "imageUrl": "assets/images/sound_on.png"
    },
    "IMG_STACK": {
        "type": "IMAGE",
        "key": "IMG_STACK",
        "imageUrl": "assets/images/stack.png"
    },
    "IMG_STAKING_SHELF_001": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_001",
        "imageUrl": "assets/images/staking_shelf_001.png"
    },
    "IMG_STAKING_SHELF_002": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_002",
        "imageUrl": "assets/images/staking_shelf_002.png"
    },
    "IMG_STAKING_SHELF_002SMALL": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_002SMALL",
        "imageUrl": "assets/images/staking_shelf_002small.png"
    },
    "IMG_STAKING_SHELF_003": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_003",
        "imageUrl": "assets/images/staking_shelf_003.png"
    },
    "IMG_STAKING_SHELF_004": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_004",
        "imageUrl": "assets/images/staking_shelf_004.png"
    },
    "IMG_STAKING_SHELF_101": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_101",
        "imageUrl": "assets/images/staking_shelf_101.png"
    },
    "IMG_STAKING_SHELF_303": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_303",
        "imageUrl": "assets/images/staking_shelf_303.png"
    },
    "IMG_STAKING_SHELF_404": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_404",
        "imageUrl": "assets/images/staking_shelf_404.png"
    },
    "IMG_STAKING_SHELF_SHAPE": {
        "type": "IMAGE",
        "key": "IMG_STAKING_SHELF_SHAPE",
        "imageUrl": "assets/images/staking_shelf_shape.png"
    },
    "IMG_STAMINA": {
        "type": "IMAGE",
        "key": "IMG_STAMINA",
        "imageUrl": "assets/images/stamina.png"
    },
    "IMG_START": {
        "type": "IMAGE",
        "key": "IMG_START",
        "imageUrl": "assets/images/start.png"
    },
    "IMG_SUGAR_BOARD": {
        "type": "IMAGE",
        "key": "IMG_SUGAR_BOARD",
        "imageUrl": "assets/images/sugar_board.png"
    },
    "IMG_SUGARCANE_BOARD": {
        "type": "IMAGE",
        "key": "IMG_SUGARCANE_BOARD",
        "imageUrl": "assets/images/sugarcane_board.png"
    },
    "IMG_SUGER": {
        "type": "IMAGE",
        "key": "IMG_SUGER",
        "imageUrl": "assets/images/suger.png"
    },
    "IMG_SUGERCANE_01": {
        "type": "IMAGE",
        "key": "IMG_SUGERCANE_01",
        "imageUrl": "assets/images/sugercane_01.png"
    },
    "IMG_SUGERCANE_MACHINE": {
        "type": "IMAGE",
        "key": "IMG_SUGERCANE_MACHINE",
        "imageUrl": "assets/images/sugercane_machine.png"
    },
    "IMG_SUGERCANE_PLANT": {
        "type": "IMAGE",
        "key": "IMG_SUGERCANE_PLANT",
        "imageUrl": "assets/images/sugercane_plant.png"
    },
    "IMG_SUGERCANE": {
        "type": "IMAGE",
        "key": "IMG_SUGERCANE",
        "imageUrl": "assets/images/sugercane.png"
    },
    "IMG_TABLE_01_2": {
        "type": "IMAGE",
        "key": "IMG_TABLE_01_2",
        "imageUrl": "assets/images/table_01_2.png"
    },
    "IMG_TABLE_01": {
        "type": "IMAGE",
        "key": "IMG_TABLE_01",
        "imageUrl": "assets/images/table_01.png"
    },
    "IMG_TABLE_02": {
        "type": "IMAGE",
        "key": "IMG_TABLE_02",
        "imageUrl": "assets/images/table_02.png"
    },
    "IMG_TABLE_03": {
        "type": "IMAGE",
        "key": "IMG_TABLE_03",
        "imageUrl": "assets/images/table_03.png"
    },
    "IMG_TAKE_BREAK": {
        "type": "IMAGE",
        "key": "IMG_TAKE_BREAK",
        "imageUrl": "assets/images/take_break.png"
    },
    "IMG_TITLE": {
        "type": "IMAGE",
        "key": "IMG_TITLE",
        "imageUrl": "assets/images/title.png"
    },
    "IMG_TREE_01": {
        "type": "IMAGE",
        "key": "IMG_TREE_01",
        "imageUrl": "assets/images/tree_01.png"
    },
    "IMG_TREE_02": {
        "type": "IMAGE",
        "key": "IMG_TREE_02",
        "imageUrl": "assets/images/tree_02.png"
    },
    "IMG_TROLLY": {
        "type": "IMAGE",
        "key": "IMG_TROLLY",
        "imageUrl": "assets/images/trolly.png"
    },
    "IMG_UPGRADE_BTN": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE_BTN",
        "imageUrl": "assets/images/upgrade_btn.png"
    },
    "IMG_UPGRADE": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE",
        "imageUrl": "assets/images/upgrade.png"
    },
    "IMG_UPGRADEBTNONGAME": {
        "type": "IMAGE",
        "key": "IMG_UPGRADEBTNONGAME",
        "imageUrl": "assets/images/upgradebtnongame.png"
    },
    "IMG_WALL_01": {
        "type": "IMAGE",
        "key": "IMG_WALL_01",
        "imageUrl": "assets/images/wall_01.png"
    },
    "IMG_WALL_02": {
        "type": "IMAGE",
        "key": "IMG_WALL_02",
        "imageUrl": "assets/images/wall_02.png"
    },
    "IMG_WALL_03": {
        "type": "IMAGE",
        "key": "IMG_WALL_03",
        "imageUrl": "assets/images/wall_03.png"
    },
    "IMG_WATCH_ADS_MSG": {
        "type": "IMAGE",
        "key": "IMG_WATCH_ADS_MSG",
        "imageUrl": "assets/images/watch_ads_msg.png"
    },
    "IMG_WATCH_ADS_TITLE": {
        "type": "IMAGE",
        "key": "IMG_WATCH_ADS_TITLE",
        "imageUrl": "assets/images/watch_ads_title.png"
    },
    "IMG_WATCH_ADS": {
        "type": "IMAGE",
        "key": "IMG_WATCH_ADS",
        "imageUrl": "assets/images/watch_ads.png"
    },
    "IMG_WATCH_VDO": {
        "type": "IMAGE",
        "key": "IMG_WATCH_VDO",
        "imageUrl": "assets/images/watch_vdo.png"
    },
    "IMG_WATCH_VDO2": {
        "type": "IMAGE",
        "key": "IMG_WATCH_VDO2",
        "imageUrl": "assets/images/watch_vdo2.png"
    },
    "IMG_WINE_BOARD": {
        "type": "IMAGE",
        "key": "IMG_WINE_BOARD",
        "imageUrl": "assets/images/wine_board.png"
    },
    "IMG_WINE_MACHINE": {
        "type": "IMAGE",
        "key": "IMG_WINE_MACHINE",
        "imageUrl": "assets/images/wine_machine.png"
    },
    "IMG_WINE": {
        "type": "IMAGE",
        "key": "IMG_WINE",
        "imageUrl": "assets/images/wine.png"
    },
    "ATLAS_ADS": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_ADS",
        "imageUrl": "assets/images/ads.png",
        "jsonUrl": "assets/images/ads.json"
    },
    "ATLAS_ANIM": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_ANIM",
        "imageUrl": "assets/images/anim.png",
        "jsonUrl": "assets/images/anim.json"
    },
    "ATLAS_CACHIER_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CACHIER_IDLE",
        "imageUrl": "assets/images/cachier_idle.png",
        "jsonUrl": "assets/images/cachier_idle.json"
    },
    "ATLAS_CUST1IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST1IDLE",
        "imageUrl": "assets/images/cust1idle.png",
        "jsonUrl": "assets/images/cust1idle.json"
    },
    "ATLAS_CUST1RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST1RUN",
        "imageUrl": "assets/images/cust1run.png",
        "jsonUrl": "assets/images/cust1run.json"
    },
    "ATLAS_CUST2IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST2IDLE",
        "imageUrl": "assets/images/cust2idle.png",
        "jsonUrl": "assets/images/cust2idle.json"
    },
    "ATLAS_CUST2RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST2RUN",
        "imageUrl": "assets/images/cust2run.png",
        "jsonUrl": "assets/images/cust2run.json"
    },
    "ATLAS_CUST3IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST3IDLE",
        "imageUrl": "assets/images/cust3idle.png",
        "jsonUrl": "assets/images/cust3idle.json"
    },
    "ATLAS_CUST3RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST3RUN",
        "imageUrl": "assets/images/cust3run.png",
        "jsonUrl": "assets/images/cust3run.json"
    },
    "ATLAS_CUST4IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST4IDLE",
        "imageUrl": "assets/images/cust4idle.png",
        "jsonUrl": "assets/images/cust4idle.json"
    },
    "ATLAS_CUST4RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST4RUN",
        "imageUrl": "assets/images/cust4run.png",
        "jsonUrl": "assets/images/cust4run.json"
    },
    "ATLAS_CUST5IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST5IDLE",
        "imageUrl": "assets/images/cust5idle.png",
        "jsonUrl": "assets/images/cust5idle.json"
    },
    "ATLAS_CUST5RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_CUST5RUN",
        "imageUrl": "assets/images/cust5run.png",
        "jsonUrl": "assets/images/cust5run.json"
    },
    "ATLAS_EFFECT": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_EFFECT",
        "imageUrl": "assets/images/effect.png",
        "jsonUrl": "assets/images/effect.json"
    },
    "ATLAS_HELPER_GRAPE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_GRAPE_IDLE",
        "imageUrl": "assets/images/helper_grape_idle.png",
        "jsonUrl": "assets/images/helper_grape_idle.json"
    },
    "ATLAS_HELPER_GRAPE_RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_GRAPE_RUN",
        "imageUrl": "assets/images/helper_grape_run.png",
        "jsonUrl": "assets/images/helper_grape_run.json"
    },
    "ATLAS_HELPER_GRAPE_SLEEP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_GRAPE_SLEEP",
        "imageUrl": "assets/images/helper_grape_sleep.png",
        "jsonUrl": "assets/images/helper_grape_sleep.json"
    },
    "ATLAS_HELPER_ORANGE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_ORANGE_IDLE",
        "imageUrl": "assets/images/helper_orange_idle.png",
        "jsonUrl": "assets/images/helper_orange_idle.json"
    },
    "ATLAS_HELPER_ORANGE_RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_ORANGE_RUN",
        "imageUrl": "assets/images/helper_orange_run.png",
        "jsonUrl": "assets/images/helper_orange_run.json"
    },
    "ATLAS_HELPER_ORANGE_SLEEP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_ORANGE_SLEEP",
        "imageUrl": "assets/images/helper_orange_sleep.png",
        "jsonUrl": "assets/images/helper_orange_sleep.json"
    },
    "ATLAS_HELPER_PINEAPPLE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_PINEAPPLE_IDLE",
        "imageUrl": "assets/images/helper_pineapple_idle.png",
        "jsonUrl": "assets/images/helper_pineapple_idle.json"
    },
    "ATLAS_HELPER_PINEAPPLE_RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_PINEAPPLE_RUN",
        "imageUrl": "assets/images/helper_pineapple_run.png",
        "jsonUrl": "assets/images/helper_pineapple_run.json"
    },
    "ATLAS_HELPER_PINEAPPLE_SLEEP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_PINEAPPLE_SLEEP",
        "imageUrl": "assets/images/helper_pineapple_sleep.png",
        "jsonUrl": "assets/images/helper_pineapple_sleep.json"
    },
    "ATLAS_HELPER_SUGARCANE_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_SUGARCANE_IDLE",
        "imageUrl": "assets/images/helper_sugarcane_idle.png",
        "jsonUrl": "assets/images/helper_sugarcane_idle.json"
    },
    "ATLAS_HELPER_SUGARCANE_RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_SUGARCANE_RUN",
        "imageUrl": "assets/images/helper_sugarcane_run.png",
        "jsonUrl": "assets/images/helper_sugarcane_run.json"
    },
    "ATLAS_HELPER_SUGARCANE_SLEEP": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HELPER_SUGARCANE_SLEEP",
        "imageUrl": "assets/images/helper_sugarcane_sleep.png",
        "jsonUrl": "assets/images/helper_sugarcane_sleep.json"
    },
    "ATLAS_HERO1IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HERO1IDLE",
        "imageUrl": "assets/images/hero1idle.png",
        "jsonUrl": "assets/images/hero1idle.json"
    },
    "ATLAS_HERO1RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HERO1RUN",
        "imageUrl": "assets/images/hero1run.png",
        "jsonUrl": "assets/images/hero1run.json"
    },
    "ATLAS_HERO2IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HERO2IDLE",
        "imageUrl": "assets/images/hero2idle.png",
        "jsonUrl": "assets/images/hero2idle.json"
    },
    "ATLAS_HERO2RUN": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HERO2RUN",
        "imageUrl": "assets/images/hero2run.png",
        "jsonUrl": "assets/images/hero2run.json"
    },
    "FRAME_ADS_WATCHADS_BOARD1": "watchads_board1",
    "FRAME_ADS_WATCHADS_BOARD2": "watchads_board2",
    "FRAME_ADS_WATCHADS_BOARD3": "watchads_board3",
    "FRAME_ADS_WATCHADS_BOARD4": "watchads_board4",
    "FRAME_ANIM_EFFECT0001": "effect0001",
    "FRAME_ANIM_EFFECT0002": "effect0002",
    "FRAME_ANIM_EFFECT0003": "effect0003",
    "FRAME_ANIM_EFFECT0004": "effect0004",
    "FRAME_ANIM_EFFECT0005": "effect0005",
    "FRAME_ANIM_EFFECT0006": "effect0006",
    "FRAME_ANIM_EFFECT0007": "effect0007",
    "FRAME_ANIM_EFFECT0008": "effect0008",
    "FRAME_ANIM_EFFECT0009": "effect0009",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0001": "cachier_idle_0001",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0002": "cachier_idle_0002",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0003": "cachier_idle_0003",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0004": "cachier_idle_0004",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0005": "cachier_idle_0005",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0006": "cachier_idle_0006",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0007": "cachier_idle_0007",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0008": "cachier_idle_0008",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0009": "cachier_idle_0009",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0010": "cachier_idle_0010",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0011": "cachier_idle_0011",
    "FRAME_CACHIER_IDLE_CACHIER_IDLE_0012": "cachier_idle_0012",
    "FRAME_CUST1IDLE_CUST1_IDLE_0001": "cust1_idle_0001",
    "FRAME_CUST1IDLE_CUST1_IDLE_0002": "cust1_idle_0002",
    "FRAME_CUST1IDLE_CUST1_IDLE_0003": "cust1_idle_0003",
    "FRAME_CUST1IDLE_CUST1_IDLE_0004": "cust1_idle_0004",
    "FRAME_CUST1IDLE_CUST1_IDLE_0005": "cust1_idle_0005",
    "FRAME_CUST1IDLE_CUST1_IDLE_0006": "cust1_idle_0006",
    "FRAME_CUST1IDLE_CUST1_IDLE_0007": "cust1_idle_0007",
    "FRAME_CUST1IDLE_CUST1_IDLE_0008": "cust1_idle_0008",
    "FRAME_CUST1IDLE_CUST1_IDLE_0009": "cust1_idle_0009",
    "FRAME_CUST1IDLE_CUST1_IDLE_0010": "cust1_idle_0010",
    "FRAME_CUST1IDLE_CUST1_IDLE_0011": "cust1_idle_0011",
    "FRAME_CUST1IDLE_CUST1_IDLE_0012": "cust1_idle_0012",
    "FRAME_CUST1RUN_CUST1_RUN_0001": "cust1_run_0001",
    "FRAME_CUST1RUN_CUST1_RUN_0002": "cust1_run_0002",
    "FRAME_CUST1RUN_CUST1_RUN_0003": "cust1_run_0003",
    "FRAME_CUST1RUN_CUST1_RUN_0004": "cust1_run_0004",
    "FRAME_CUST1RUN_CUST1_RUN_0005": "cust1_run_0005",
    "FRAME_CUST1RUN_CUST1_RUN_0006": "cust1_run_0006",
    "FRAME_CUST1RUN_CUST1_RUN_0007": "cust1_run_0007",
    "FRAME_CUST1RUN_CUST1_RUN_0008": "cust1_run_0008",
    "FRAME_CUST1RUN_CUST1_RUN_0009": "cust1_run_0009",
    "FRAME_CUST1RUN_CUST1_RUN_0010": "cust1_run_0010",
    "FRAME_CUST2IDLE_CUST2_IDLE_0001": "cust2_idle_0001",
    "FRAME_CUST2IDLE_CUST2_IDLE_0002": "cust2_idle_0002",
    "FRAME_CUST2IDLE_CUST2_IDLE_0003": "cust2_idle_0003",
    "FRAME_CUST2IDLE_CUST2_IDLE_0004": "cust2_idle_0004",
    "FRAME_CUST2IDLE_CUST2_IDLE_0005": "cust2_idle_0005",
    "FRAME_CUST2IDLE_CUST2_IDLE_0006": "cust2_idle_0006",
    "FRAME_CUST2IDLE_CUST2_IDLE_0007": "cust2_idle_0007",
    "FRAME_CUST2IDLE_CUST2_IDLE_0008": "cust2_idle_0008",
    "FRAME_CUST2IDLE_CUST2_IDLE_0009": "cust2_idle_0009",
    "FRAME_CUST2IDLE_CUST2_IDLE_0010": "cust2_idle_0010",
    "FRAME_CUST2IDLE_CUST2_IDLE_0011": "cust2_idle_0011",
    "FRAME_CUST2IDLE_CUST2_IDLE_0012": "cust2_idle_0012",
    "FRAME_CUST2RUN_CUST2_RUN_0001": "cust2_run_0001",
    "FRAME_CUST2RUN_CUST2_RUN_0002": "cust2_run_0002",
    "FRAME_CUST2RUN_CUST2_RUN_0003": "cust2_run_0003",
    "FRAME_CUST2RUN_CUST2_RUN_0004": "cust2_run_0004",
    "FRAME_CUST2RUN_CUST2_RUN_0005": "cust2_run_0005",
    "FRAME_CUST2RUN_CUST2_RUN_0006": "cust2_run_0006",
    "FRAME_CUST2RUN_CUST2_RUN_0007": "cust2_run_0007",
    "FRAME_CUST2RUN_CUST2_RUN_0008": "cust2_run_0008",
    "FRAME_CUST2RUN_CUST2_RUN_0009": "cust2_run_0009",
    "FRAME_CUST2RUN_CUST2_RUN_0010": "cust2_run_0010",
    "FRAME_CUST3IDLE_CUST3_IDLE_0001": "cust3_idle_0001",
    "FRAME_CUST3IDLE_CUST3_IDLE_0002": "cust3_idle_0002",
    "FRAME_CUST3IDLE_CUST3_IDLE_0003": "cust3_idle_0003",
    "FRAME_CUST3IDLE_CUST3_IDLE_0004": "cust3_idle_0004",
    "FRAME_CUST3IDLE_CUST3_IDLE_0005": "cust3_idle_0005",
    "FRAME_CUST3IDLE_CUST3_IDLE_0006": "cust3_idle_0006",
    "FRAME_CUST3IDLE_CUST3_IDLE_0007": "cust3_idle_0007",
    "FRAME_CUST3IDLE_CUST3_IDLE_0008": "cust3_idle_0008",
    "FRAME_CUST3IDLE_CUST3_IDLE_0009": "cust3_idle_0009",
    "FRAME_CUST3IDLE_CUST3_IDLE_0010": "cust3_idle_0010",
    "FRAME_CUST3IDLE_CUST3_IDLE_0011": "cust3_idle_0011",
    "FRAME_CUST3IDLE_CUST3_IDLE_0012": "cust3_idle_0012",
    "FRAME_CUST3RUN_CUST3_RUN_0001": "cust3_run_0001",
    "FRAME_CUST3RUN_CUST3_RUN_0002": "cust3_run_0002",
    "FRAME_CUST3RUN_CUST3_RUN_0003": "cust3_run_0003",
    "FRAME_CUST3RUN_CUST3_RUN_0004": "cust3_run_0004",
    "FRAME_CUST3RUN_CUST3_RUN_0005": "cust3_run_0005",
    "FRAME_CUST3RUN_CUST3_RUN_0006": "cust3_run_0006",
    "FRAME_CUST3RUN_CUST3_RUN_0007": "cust3_run_0007",
    "FRAME_CUST3RUN_CUST3_RUN_0008": "cust3_run_0008",
    "FRAME_CUST3RUN_CUST3_RUN_0009": "cust3_run_0009",
    "FRAME_CUST3RUN_CUST3_RUN_0010": "cust3_run_0010",
    "FRAME_CUST4IDLE_CUST4_IDLE_0001": "cust4_idle_0001",
    "FRAME_CUST4IDLE_CUST4_IDLE_0002": "cust4_idle_0002",
    "FRAME_CUST4IDLE_CUST4_IDLE_0003": "cust4_idle_0003",
    "FRAME_CUST4IDLE_CUST4_IDLE_0004": "cust4_idle_0004",
    "FRAME_CUST4IDLE_CUST4_IDLE_0005": "cust4_idle_0005",
    "FRAME_CUST4IDLE_CUST4_IDLE_0006": "cust4_idle_0006",
    "FRAME_CUST4IDLE_CUST4_IDLE_0007": "cust4_idle_0007",
    "FRAME_CUST4IDLE_CUST4_IDLE_0008": "cust4_idle_0008",
    "FRAME_CUST4IDLE_CUST4_IDLE_0009": "cust4_idle_0009",
    "FRAME_CUST4IDLE_CUST4_IDLE_0010": "cust4_idle_0010",
    "FRAME_CUST4IDLE_CUST4_IDLE_0011": "cust4_idle_0011",
    "FRAME_CUST4IDLE_CUST4_IDLE_0012": "cust4_idle_0012",
    "FRAME_CUST4RUN_CUST4_RUN_0001": "cust4_run_0001",
    "FRAME_CUST4RUN_CUST4_RUN_0002": "cust4_run_0002",
    "FRAME_CUST4RUN_CUST4_RUN_0003": "cust4_run_0003",
    "FRAME_CUST4RUN_CUST4_RUN_0004": "cust4_run_0004",
    "FRAME_CUST4RUN_CUST4_RUN_0005": "cust4_run_0005",
    "FRAME_CUST4RUN_CUST4_RUN_0006": "cust4_run_0006",
    "FRAME_CUST4RUN_CUST4_RUN_0007": "cust4_run_0007",
    "FRAME_CUST4RUN_CUST4_RUN_0008": "cust4_run_0008",
    "FRAME_CUST4RUN_CUST4_RUN_0009": "cust4_run_0009",
    "FRAME_CUST4RUN_CUST4_RUN_0010": "cust4_run_0010",
    "FRAME_CUST5IDLE_CUST5_IDLE_0001": "cust5_idle_0001",
    "FRAME_CUST5IDLE_CUST5_IDLE_0002": "cust5_idle_0002",
    "FRAME_CUST5IDLE_CUST5_IDLE_0003": "cust5_idle_0003",
    "FRAME_CUST5IDLE_CUST5_IDLE_0004": "cust5_idle_0004",
    "FRAME_CUST5IDLE_CUST5_IDLE_0005": "cust5_idle_0005",
    "FRAME_CUST5IDLE_CUST5_IDLE_0006": "cust5_idle_0006",
    "FRAME_CUST5IDLE_CUST5_IDLE_0007": "cust5_idle_0007",
    "FRAME_CUST5IDLE_CUST5_IDLE_0008": "cust5_idle_0008",
    "FRAME_CUST5IDLE_CUST5_IDLE_0009": "cust5_idle_0009",
    "FRAME_CUST5IDLE_CUST5_IDLE_0010": "cust5_idle_0010",
    "FRAME_CUST5IDLE_CUST5_IDLE_0011": "cust5_idle_0011",
    "FRAME_CUST5IDLE_CUST5_IDLE_0012": "cust5_idle_0012",
    "FRAME_CUST5RUN_CUST5_RUN_0001": "cust5_run_0001",
    "FRAME_CUST5RUN_CUST5_RUN_0002": "cust5_run_0002",
    "FRAME_CUST5RUN_CUST5_RUN_0003": "cust5_run_0003",
    "FRAME_CUST5RUN_CUST5_RUN_0004": "cust5_run_0004",
    "FRAME_CUST5RUN_CUST5_RUN_0005": "cust5_run_0005",
    "FRAME_CUST5RUN_CUST5_RUN_0006": "cust5_run_0006",
    "FRAME_CUST5RUN_CUST5_RUN_0007": "cust5_run_0007",
    "FRAME_CUST5RUN_CUST5_RUN_0008": "cust5_run_0008",
    "FRAME_CUST5RUN_CUST5_RUN_0009": "cust5_run_0009",
    "FRAME_CUST5RUN_CUST5_RUN_0010": "cust5_run_0010",
    "FRAME_EFFECT_EFFECT_0001": "effect_0001",
    "FRAME_EFFECT_EFFECT_0002": "effect_0002",
    "FRAME_EFFECT_EFFECT_0003": "effect_0003",
    "FRAME_EFFECT_EFFECT_0004": "effect_0004",
    "FRAME_EFFECT_EFFECT_0005": "effect_0005",
    "FRAME_EFFECT_EFFECT_0006": "effect_0006",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0001": "helper_grape_idle_0001",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0002": "helper_grape_idle_0002",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0003": "helper_grape_idle_0003",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0004": "helper_grape_idle_0004",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0005": "helper_grape_idle_0005",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0006": "helper_grape_idle_0006",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0007": "helper_grape_idle_0007",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0008": "helper_grape_idle_0008",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0009": "helper_grape_idle_0009",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0010": "helper_grape_idle_0010",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0011": "helper_grape_idle_0011",
    "FRAME_HELPER_GRAPE_IDLE_HELPER_GRAPE_IDLE_0012": "helper_grape_idle_0012",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0001": "helper_grape_run_0001",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0002": "helper_grape_run_0002",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0003": "helper_grape_run_0003",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0004": "helper_grape_run_0004",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0005": "helper_grape_run_0005",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0006": "helper_grape_run_0006",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0007": "helper_grape_run_0007",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0008": "helper_grape_run_0008",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0009": "helper_grape_run_0009",
    "FRAME_HELPER_GRAPE_RUN_HELPER_GRAPE_RUN_0010": "helper_grape_run_0010",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0001": "helper_grape_sleep_0001",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0002": "helper_grape_sleep_0002",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0003": "helper_grape_sleep_0003",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0004": "helper_grape_sleep_0004",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0005": "helper_grape_sleep_0005",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0006": "helper_grape_sleep_0006",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0007": "helper_grape_sleep_0007",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0008": "helper_grape_sleep_0008",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0009": "helper_grape_sleep_0009",
    "FRAME_HELPER_GRAPE_SLEEP_HELPER_GRAPE_SLEEP_0010": "helper_grape_sleep_0010",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0001": "helper_orange_idle_0001",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0002": "helper_orange_idle_0002",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0003": "helper_orange_idle_0003",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0004": "helper_orange_idle_0004",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0005": "helper_orange_idle_0005",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0006": "helper_orange_idle_0006",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0007": "helper_orange_idle_0007",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0008": "helper_orange_idle_0008",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0009": "helper_orange_idle_0009",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0010": "helper_orange_idle_0010",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0011": "helper_orange_idle_0011",
    "FRAME_HELPER_ORANGE_IDLE_HELPER_ORANGE_IDLE_0012": "helper_orange_idle_0012",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0001": "helper_orange_run_0001",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0002": "helper_orange_run_0002",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0003": "helper_orange_run_0003",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0004": "helper_orange_run_0004",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0005": "helper_orange_run_0005",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0006": "helper_orange_run_0006",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0007": "helper_orange_run_0007",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0008": "helper_orange_run_0008",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0009": "helper_orange_run_0009",
    "FRAME_HELPER_ORANGE_RUN_HELPER_ORANGE_RUN_0010": "helper_orange_run_0010",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0001": "helper_orange_sleep_0001",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0002": "helper_orange_sleep_0002",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0003": "helper_orange_sleep_0003",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0004": "helper_orange_sleep_0004",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0005": "helper_orange_sleep_0005",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0006": "helper_orange_sleep_0006",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0007": "helper_orange_sleep_0007",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0008": "helper_orange_sleep_0008",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0009": "helper_orange_sleep_0009",
    "FRAME_HELPER_ORANGE_SLEEP_HELPER_ORANGE_SLEEP_0010": "helper_orange_sleep_0010",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0001": "helper_pineapple_idle_0001",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0002": "helper_pineapple_idle_0002",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0003": "helper_pineapple_idle_0003",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0004": "helper_pineapple_idle_0004",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0005": "helper_pineapple_idle_0005",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0006": "helper_pineapple_idle_0006",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0007": "helper_pineapple_idle_0007",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0008": "helper_pineapple_idle_0008",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0009": "helper_pineapple_idle_0009",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0010": "helper_pineapple_idle_0010",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0011": "helper_pineapple_idle_0011",
    "FRAME_HELPER_PINEAPPLE_IDLE_HELPER_PINEAPPLE_IDLE_0012": "helper_pineapple_idle_0012",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0001": "helper_pineapple_run_0001",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0002": "helper_pineapple_run_0002",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0003": "helper_pineapple_run_0003",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0004": "helper_pineapple_run_0004",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0005": "helper_pineapple_run_0005",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0006": "helper_pineapple_run_0006",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0007": "helper_pineapple_run_0007",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0008": "helper_pineapple_run_0008",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0009": "helper_pineapple_run_0009",
    "FRAME_HELPER_PINEAPPLE_RUN_HELPER_PINEAPPLE_RUN_0010": "helper_pineapple_run_0010",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0001": "helper_pineapple_sleep_0001",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0002": "helper_pineapple_sleep_0002",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0003": "helper_pineapple_sleep_0003",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0004": "helper_pineapple_sleep_0004",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0005": "helper_pineapple_sleep_0005",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0006": "helper_pineapple_sleep_0006",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0007": "helper_pineapple_sleep_0007",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0008": "helper_pineapple_sleep_0008",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0009": "helper_pineapple_sleep_0009",
    "FRAME_HELPER_PINEAPPLE_SLEEP_HELPER_PINEAPPLE_SLEEP_0010": "helper_pineapple_sleep_0010",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0001": "helper_sugarcane_idle_0001",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0002": "helper_sugarcane_idle_0002",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0003": "helper_sugarcane_idle_0003",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0004": "helper_sugarcane_idle_0004",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0005": "helper_sugarcane_idle_0005",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0006": "helper_sugarcane_idle_0006",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0007": "helper_sugarcane_idle_0007",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0008": "helper_sugarcane_idle_0008",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0009": "helper_sugarcane_idle_0009",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0010": "helper_sugarcane_idle_0010",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0011": "helper_sugarcane_idle_0011",
    "FRAME_HELPER_SUGARCANE_IDLE_HELPER_SUGARCANE_IDLE_0012": "helper_sugarcane_idle_0012",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0001": "helper_sugarcane_run_0001",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0002": "helper_sugarcane_run_0002",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0003": "helper_sugarcane_run_0003",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0004": "helper_sugarcane_run_0004",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0005": "helper_sugarcane_run_0005",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0006": "helper_sugarcane_run_0006",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0007": "helper_sugarcane_run_0007",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0008": "helper_sugarcane_run_0008",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0009": "helper_sugarcane_run_0009",
    "FRAME_HELPER_SUGARCANE_RUN_HELPER_SUGARCANE_RUN_0010": "helper_sugarcane_run_0010",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0001": "helper_sugarcane_sleep_0001",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0002": "helper_sugarcane_sleep_0002",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0003": "helper_sugarcane_sleep_0003",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0004": "helper_sugarcane_sleep_0004",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0005": "helper_sugarcane_sleep_0005",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0006": "helper_sugarcane_sleep_0006",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0007": "helper_sugarcane_sleep_0007",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0008": "helper_sugarcane_sleep_0008",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0009": "helper_sugarcane_sleep_0009",
    "FRAME_HELPER_SUGARCANE_SLEEP_HELPER_SUGARCANE_SLEEP_0010": "helper_sugarcane_sleep_0010",
    "FRAME_HERO1IDLE_HERO1_IDLE_0001": "hero1_idle_0001",
    "FRAME_HERO1IDLE_HERO1_IDLE_0002": "hero1_idle_0002",
    "FRAME_HERO1IDLE_HERO1_IDLE_0003": "hero1_idle_0003",
    "FRAME_HERO1IDLE_HERO1_IDLE_0004": "hero1_idle_0004",
    "FRAME_HERO1IDLE_HERO1_IDLE_0005": "hero1_idle_0005",
    "FRAME_HERO1IDLE_HERO1_IDLE_0006": "hero1_idle_0006",
    "FRAME_HERO1IDLE_HERO1_IDLE_0007": "hero1_idle_0007",
    "FRAME_HERO1IDLE_HERO1_IDLE_0008": "hero1_idle_0008",
    "FRAME_HERO1IDLE_HERO1_IDLE_0009": "hero1_idle_0009",
    "FRAME_HERO1IDLE_HERO1_IDLE_0010": "hero1_idle_0010",
    "FRAME_HERO1IDLE_HERO1_IDLE_0011": "hero1_idle_0011",
    "FRAME_HERO1IDLE_HERO1_IDLE_0012": "hero1_idle_0012",
    "FRAME_HERO1RUN_HERO1_RUN_0001": "hero1_run_0001",
    "FRAME_HERO1RUN_HERO1_RUN_0002": "hero1_run_0002",
    "FRAME_HERO1RUN_HERO1_RUN_0003": "hero1_run_0003",
    "FRAME_HERO1RUN_HERO1_RUN_0004": "hero1_run_0004",
    "FRAME_HERO1RUN_HERO1_RUN_0005": "hero1_run_0005",
    "FRAME_HERO1RUN_HERO1_RUN_0006": "hero1_run_0006",
    "FRAME_HERO1RUN_HERO1_RUN_0007": "hero1_run_0007",
    "FRAME_HERO1RUN_HERO1_RUN_0008": "hero1_run_0008",
    "FRAME_HERO1RUN_HERO1_RUN_0009": "hero1_run_0009",
    "FRAME_HERO1RUN_HERO1_RUN_0010": "hero1_run_0010",
    "FRAME_HERO2IDLE_HERO2_IDLE_0001": "hero2_idle_0001",
    "FRAME_HERO2IDLE_HERO2_IDLE_0002": "hero2_idle_0002",
    "FRAME_HERO2IDLE_HERO2_IDLE_0003": "hero2_idle_0003",
    "FRAME_HERO2IDLE_HERO2_IDLE_0004": "hero2_idle_0004",
    "FRAME_HERO2IDLE_HERO2_IDLE_0005": "hero2_idle_0005",
    "FRAME_HERO2IDLE_HERO2_IDLE_0006": "hero2_idle_0006",
    "FRAME_HERO2IDLE_HERO2_IDLE_0007": "hero2_idle_0007",
    "FRAME_HERO2IDLE_HERO2_IDLE_0008": "hero2_idle_0008",
    "FRAME_HERO2IDLE_HERO2_IDLE_0009": "hero2_idle_0009",
    "FRAME_HERO2IDLE_HERO2_IDLE_0010": "hero2_idle_0010",
    "FRAME_HERO2IDLE_HERO2_IDLE_0011": "hero2_idle_0011",
    "FRAME_HERO2IDLE_HERO2_IDLE_0012": "hero2_idle_0012",
    "FRAME_HERO2RUN_HERO2_RUN_0001": "hero2_run_0001",
    "FRAME_HERO2RUN_HERO2_RUN_0002": "hero2_run_0002",
    "FRAME_HERO2RUN_HERO2_RUN_0003": "hero2_run_0003",
    "FRAME_HERO2RUN_HERO2_RUN_0004": "hero2_run_0004",
    "FRAME_HERO2RUN_HERO2_RUN_0005": "hero2_run_0005",
    "FRAME_HERO2RUN_HERO2_RUN_0006": "hero2_run_0006",
    "FRAME_HERO2RUN_HERO2_RUN_0007": "hero2_run_0007",
    "FRAME_HERO2RUN_HERO2_RUN_0008": "hero2_run_0008",
    "FRAME_HERO2RUN_HERO2_RUN_0009": "hero2_run_0009",
    "FRAME_HERO2RUN_HERO2_RUN_0010": "hero2_run_0010",
    "AUDIOSPRITE_SOUNDS": {
        "type": "AUDIOSPRITE",
        "key": "AUDIOSPRITE_SOUNDS",
        "urls": [
            "assets/sounds/sounds.mp3"
        ],
        "jsonUrl": "assets/sounds/sounds.json"
    },
    "AUDIOSPRITE_MARKER_SILENCE": "silence",
    "AUDIOSPRITE_MARKER_BALL1": "ball1",
    "AUDIOSPRITE_MARKER_MONEY": "money",
    "AUDIOSPRITE_MARKER_MOUSE_OVER": "mouse_over",
    "AUDIOSPRITE_MARKER_MOUSECLICK": "mouseclick",
    "AUDIOSPRITE_MARKER_MUSIC": "music",
    "AUDIOSPRITE_MARKER_PRESSBTN1": "pressbtn1",
    "AUDIOSPRITE_MARKER_V_SPIKESRISING": "V_spikesrising"
}